// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddButton-module__font-s-10___kj9Hh {
  font-size: 10px !important;
}

.AddButton-module__font-s-12___kqt5B {
  font-size: 12px !important;
}

.AddButton-module__font-s-13___KeH7j {
  font-size: 13px !important;
}

.AddButton-module__font-s-14___caVei {
  font-size: 14px !important;
}

.AddButton-module__font-s-15___EUyTs {
  font-size: 15px !important;
}

.AddButton-module__font-s-16___x2upx {
  font-size: 16px !important;
}

.AddButton-module__font-s-18___jRxlu {
  font-size: 18px !important;
}

.AddButton-module__font-s-20___yUlmd {
  font-size: 20px !important;
}

.AddButton-module__font-s-22___nUzDT {
  font-size: 22px !important;
}

.AddButton-module__font-s-28___RjWWw {
  font-size: 28px !important;
}

.AddButton-module__font-w-400___XPmbm {
  font-weight: 400 !important;
}

.AddButton-module__font-w-500___jxYYM {
  font-weight: 500 !important;
}

.AddButton-module__font-w-600___Vg34i {
  font-weight: 600 !important;
}

.AddButton-module__font-w-700___FkH3b {
  font-weight: 700 !important;
}

.AddButton-module__p-5___AoXnh {
  padding: 5px !important;
}

.AddButton-module__p-12___ubJ2h {
  padding: 12px !important;
}

.AddButton-module__p-16___WSKRE {
  padding: 16px !important;
}

.AddButton-module__p-30___UOM4M {
  padding: 30px !important;
}

.AddButton-module__p-b-0___pfFZW {
  padding-bottom: 0 !important;
}

.AddButton-module__p-b-5___IuptC {
  padding-bottom: 5px !important;
}

.AddButton-module__p-b-10___h__rC {
  padding-bottom: 10px !important;
}

.AddButton-module__p-b-12___jM51p {
  padding-bottom: 12px !important;
}

.AddButton-module__p-b-16___qDJMx {
  padding-bottom: 16px !important;
}

.AddButton-module__p-b-18___mMV_R {
  padding-bottom: 18px !important;
}

.AddButton-module__p-b-20___WCooU {
  padding-bottom: 20px !important;
}

.AddButton-module__p-b-25___M6vtA {
  padding-bottom: 25px !important;
}

.AddButton-module__p-b-30___W9T0P {
  padding-bottom: 30px !important;
}

.AddButton-module__p-b-50___sWrBl {
  padding-bottom: 50px !important;
}

.AddButton-module__p-t-0___pGP5w {
  padding-top: 0 !important;
}

.AddButton-module__p-t-12___dAv64 {
  padding-top: 12px !important;
}

.AddButton-module__p-t-16___U80jw {
  padding-top: 16px !important;
}

.AddButton-module__p-t-18___WdXmw {
  padding-top: 18px !important;
}

.AddButton-module__p-t-20___bu1x4 {
  padding-top: 20px !important;
}

.AddButton-module__p-t-30___lZXS4 {
  padding-top: 30px !important;
}

.AddButton-module__p-t-40___wjFoc {
  padding-top: 40px !important;
}

.AddButton-module__p-t-50___eDcZI {
  padding-top: 50px !important;
}

.AddButton-module__p-l-20___wtrL5 {
  padding-left: 20px !important;
}

.AddButton-module__p-l-30___iv6Bl {
  padding-left: 30px !important;
}

.AddButton-module__p-l-40___jQZFh {
  padding-left: 40px !important;
}

.AddButton-module__p-r-16___JJ0ne {
  padding-right: 16px !important;
}

.AddButton-module__p-r-20___CYadp {
  padding-right: 20px !important;
}

.AddButton-module__p-r-30___UIIOy {
  padding-right: 30px !important;
}

.AddButton-module__p-r-50___BMjNX {
  padding-right: 50px !important;
}

.AddButton-module__p-r-60___p3kuf {
  padding-right: 60px !important;
}

.AddButton-module__m-b-1___U2ftr {
  margin-bottom: 1px !important;
}

.AddButton-module__m-b-2___d4WqM {
  margin-bottom: 2px !important;
}

.AddButton-module__m-b-6___eeyct {
  margin-bottom: 6px !important;
}

.AddButton-module__m-b-8___cOJR0 {
  margin-bottom: 8px !important;
}

.AddButton-module__m-b-10___aj2tu {
  margin-bottom: 10px !important;
}

.AddButton-module__m-b-14___vogDk {
  margin-bottom: 14px !important;
}

.AddButton-module__m-b-16___AYM4i {
  margin-bottom: 16px !important;
}

.AddButton-module__m-b-20___Iv2zJ {
  margin-bottom: 20px !important;
}

.AddButton-module__m-b-22___OphHL {
  margin-bottom: 22px !important;
}

.AddButton-module__m-b-24___QzLrS {
  margin-bottom: 24px !important;
}

.AddButton-module__m-b-30___Am6ze {
  margin-bottom: 30px !important;
}

.AddButton-module__m-b-32___xewkH {
  margin-bottom: 32px !important;
}

.AddButton-module__m-b-40___wEjTN {
  margin-bottom: 40px !important;
}

.AddButton-module__m-t-2___nWl4o {
  margin-top: 2px !important;
}

.AddButton-module__m-t-3___KFonQ {
  margin-top: 3px !important;
}

.AddButton-module__m-t-4___a_MqH {
  margin-top: 4px !important;
}

.AddButton-module__m-t-5___tIpt0 {
  margin-top: 5px !important;
}

.AddButton-module__m-t-8___vWehY {
  margin-top: 8px !important;
}

.AddButton-module__m-t-10___ZLdU4 {
  margin-top: 10px !important;
}

.AddButton-module__m-t-15___fR5sk {
  margin-top: 15px !important;
}

.AddButton-module__m-t-16___fJGMG {
  margin-top: 16px !important;
}

.AddButton-module__m-t-20___DBIMn {
  margin-top: 20px !important;
}

.AddButton-module__m-t-22___hZRqA {
  margin-top: 22px !important;
}

.AddButton-module__m-t-30___y9a2x {
  margin-top: 30px !important;
}

.AddButton-module__m-t-32___OZcKN {
  margin-top: 32px !important;
}

.AddButton-module__m-l-auto___GMTsu {
  margin-left: auto !important;
}

.AddButton-module__m-l-4___oiiQ4 {
  margin-left: 4px !important;
}

.AddButton-module__m-l-5___P9wrU {
  margin-left: 5px !important;
}

.AddButton-module__m-l-6___ndj17 {
  margin-left: 6px !important;
}

.AddButton-module__m-l-8___o2YZs {
  margin-left: 8px !important;
}

.AddButton-module__m-l-10___aGq7o {
  margin-left: 10px !important;
}

.AddButton-module__m-l-16___lg0Jf {
  margin-left: 16px !important;
}

.AddButton-module__m-l-20___SWbpq {
  margin-left: 20px !important;
}

.AddButton-module__m-l-24___X1wqi {
  margin-left: 24px !important;
}

.AddButton-module__m-l-30___p510b {
  margin-left: 30px !important;
}

.AddButton-module__m-l-35___AU6zi {
  margin-left: 35px !important;
}

.AddButton-module__m-l-40___nameI {
  margin-left: 40px !important;
}

.AddButton-module__m-r-8___a2_Ya {
  margin-right: 8px !important;
}

.AddButton-module__m-r-10___IYEfO {
  margin-right: 10px !important;
}

.AddButton-module__m-r-16___IPnkt {
  margin-right: 16px !important;
}

.AddButton-module__m-r-20___cPtxl {
  margin-right: 20px !important;
}

.AddButton-module__m-r-24___J4UgK {
  margin-right: 24px !important;
}

.AddButton-module__m-r-30___hx4wE {
  margin-right: 30px !important;
}

.AddButton-module__m-r-40___EJioZ {
  margin-right: 40px !important;
}

.AddButton-module__border-r-3___isKNG {
  border-radius: 3px !important;
}

.AddButton-module__border-r-4___SDSnA {
  border-radius: 4px !important;
}

.AddButton-module__border-r-6___XZBBV {
  border-radius: 6px !important;
}

.AddButton-module__border-r-10___DInwS {
  border-radius: 10px !important;
}

.AddButton-module__border-r-12___jPnYS {
  border-radius: 12px !important;
}

.AddButton-module__border-r-16___tYhWz {
  border-radius: 16px !important;
}

.AddButton-module__border-r-50___A_SEC {
  border-radius: 50% !important;
}

.AddButton-module__primary-border___TmLq5 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.AddButton-module__primary-border-b___QnUEr {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.AddButton-module__primary-border-t___kMWzv {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.AddButton-module__primary-border-l___uEyku {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.AddButton-module__primary-border-r___UIoqf {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.AddButton-module__secondary-border___Vwgsn {
  border: 1px solid #637768;
}

.AddButton-module__secondary-border-b___wfh6I {
  border-bottom: 1px solid #637768;
}

.AddButton-module__secondary-border-t___FRtL6 {
  border-top: 1px solid #637768;
}

.AddButton-module__secondary-border-l___yE4Ve {
  border-left: 1px solid #637768;
}

.AddButton-module__secondary-border-r___p9Bju {
  border-right: 1px solid #637768;
}

.AddButton-module__gap-0___dJHMH {
  gap: 0 !important;
}

.AddButton-module__gap-2___B_j_r {
  gap: 2px !important;
}

.AddButton-module__gap-4___CTwFe {
  gap: 4px !important;
}

.AddButton-module__gap-5___kd6oy {
  gap: 5px !important;
}

.AddButton-module__gap-6___RBMlo {
  gap: 6px !important;
}

.AddButton-module__gap-8___Xkc7T {
  gap: 8px !important;
}

.AddButton-module__gap-10___hHtMr {
  gap: 10px !important;
}

.AddButton-module__gap-12___GnrsF {
  gap: 12px !important;
}

.AddButton-module__gap-14___V1VhR {
  gap: 14px !important;
}

.AddButton-module__gap-16___W_sT2 {
  gap: 16px !important;
}

.AddButton-module__gap-18___ezMcJ {
  gap: 18px !important;
}

.AddButton-module__gap-20___P0_w8 {
  gap: 20px !important;
}

.AddButton-module__gap-24___t11KW {
  gap: 24px !important;
}

.AddButton-module__gap-26___Xc888 {
  gap: 26px !important;
}

.AddButton-module__gap-30___zkuFX {
  gap: 30px !important;
}

.AddButton-module__gap-32___GanZ1 {
  gap: 32px !important;
}

.AddButton-module__gap-40___ooUB0 {
  gap: 40px !important;
}

.AddButton-module__gap-50___wBchX {
  gap: 50px !important;
}

.AddButton-module__flex-1___a4emn {
  flex: 1;
}

.AddButton-module__flex-none___tOlHW {
  flex: none !important;
}

.AddButton-module__flex-column___bz1ep {
  display: flex;
  flex-direction: column !important;
}

.AddButton-module__flex-row___mahn5 {
  display: flex;
  flex-direction: row !important;
}

.AddButton-module__vertically-centered___ZTRJs {
  display: flex;
  align-items: center !important;
}

.AddButton-module__horizontally-centered___QhQGJ {
  display: flex;
  justify-content: center !important;
}

.AddButton-module__horizontally-end___c4ZM0 {
  display: flex;
  justify-content: end !important;
}

.AddButton-module__vertically-start___kiD6x {
  display: flex;
  align-items: start !important;
}

.AddButton-module__space-between___RUp5o {
  display: flex;
  justify-content: space-between !important;
}

.AddButton-module__flex-wrap___yFdE0 {
  flex-wrap: wrap !important;
}

.AddButton-module__height-100___hN1lM {
  height: 100%;
}

.AddButton-module__width-50___NLM70 {
  width: 50% !important;
}

.AddButton-module__width-100___BJs3N {
  width: 100%;
}

.AddButton-module__cursor-pointer___bByPD {
  cursor: pointer;
}

.AddButton-module__cursor-not-allowed___LtuJF {
  cursor: not-allowed !important;
}

.AddButton-module__absolute-centered___EN1VX {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.AddButton-module__absolute___pI0zI {
  position: absolute;
}

.AddButton-module__relative___BzWxA {
  position: relative;
}

.AddButton-module__fixed___fl0Po {
  position: fixed;
}

.AddButton-module__visible___N7eRH {
  opacity: 1;
}

.AddButton-module__invisible____4sd6 {
  opacity: 0;
}

.AddButton-module__col-90___KAEdM {
  width: 90% !important;
}

.AddButton-module__col-auto___kbwQc {
  width: auto !important;
}

.AddButton-module__medical-tabs___8qfEu {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.AddButton-module__medical-table-new___hflpN {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.AddButton-module__medical-table-new___hflpN:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.AddButton-module__medical-table-new___hflpN::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.AddButton-module__medical-table-new___hflpN::-webkit-scrollbar-track {
  display: none;
}
.AddButton-module__medical-table-new___hflpN.AddButton-module__no-pagination___StTo1 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.AddButton-module__medical-table-new___hflpN.AddButton-module__no-pagination___StTo1:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.AddButton-module__medical-table-new___hflpN.AddButton-module__no-pagination___StTo1::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.AddButton-module__medical-table-new___hflpN.AddButton-module__no-pagination___StTo1::-webkit-scrollbar-track {
  display: none;
}

.AddButton-module__medical-table-empty___scGyG {
  padding: 14px 40px !important;
}

.AddButton-module__icon-btn___WWLwW {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.AddButton-module__search-icon___PccBs {
  width: 24px;
  height: 24px;
  align-self: center;
}

.AddButton-module__disable-select___I64Es {
  user-select: none;
}

.AddButton-module__break-word___RpGOR {
  word-break: break-word;
}

.AddButton-module__popup-clear-btn___ASDMK {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.AddButton-module__scroll-m-b-20___Sat4c {
  scroll-margin-bottom: 20px;
}

.AddButton-module__button___vNoC4 {
  width: auto;
  flex-direction: row;
  grid-column: span 2;
  justify-content: flex-start !important;
  padding-left: 0;
}
.AddButton-module__button___vNoC4 > span {
  font-family: var(--font-family);
  font-weight: 500;
  font-size: 16px !important;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/buttons/AddButton/AddButton.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss","webpack://./../common/src/styles/global/_weights.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,sCAAA;EACA,eAAA;AA8pBF;AA5pBE;EEiBA,+BApBO;EAqBP,gBCxBO;EHQL,0BAAA;AA+pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.button {\n  width: auto;\n  flex-direction: row;\n  grid-column: span 2;\n  justify-content: flex-start !important;\n  padding-left: 0;\n\n  & > span {\n    @include get-font($roboto, $medium);\n    font-size: 16px !important;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n","$extra-light: 200;\n$light: 300;\n$regular: 400;\n$medium: 500;\n$semi-bold: 600;\n$bold: 700;\n$heavy: 900;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `AddButton-module__font-s-10___kj9Hh`,
	"fontS12": `AddButton-module__font-s-12___kqt5B`,
	"fontS13": `AddButton-module__font-s-13___KeH7j`,
	"fontS14": `AddButton-module__font-s-14___caVei`,
	"fontS15": `AddButton-module__font-s-15___EUyTs`,
	"fontS16": `AddButton-module__font-s-16___x2upx`,
	"fontS18": `AddButton-module__font-s-18___jRxlu`,
	"fontS20": `AddButton-module__font-s-20___yUlmd`,
	"fontS22": `AddButton-module__font-s-22___nUzDT`,
	"fontS28": `AddButton-module__font-s-28___RjWWw`,
	"fontW400": `AddButton-module__font-w-400___XPmbm`,
	"fontW500": `AddButton-module__font-w-500___jxYYM`,
	"fontW600": `AddButton-module__font-w-600___Vg34i`,
	"fontW700": `AddButton-module__font-w-700___FkH3b`,
	"p5": `AddButton-module__p-5___AoXnh`,
	"p12": `AddButton-module__p-12___ubJ2h`,
	"p16": `AddButton-module__p-16___WSKRE`,
	"p30": `AddButton-module__p-30___UOM4M`,
	"pB0": `AddButton-module__p-b-0___pfFZW`,
	"pB5": `AddButton-module__p-b-5___IuptC`,
	"pB10": `AddButton-module__p-b-10___h__rC`,
	"pB12": `AddButton-module__p-b-12___jM51p`,
	"pB16": `AddButton-module__p-b-16___qDJMx`,
	"pB18": `AddButton-module__p-b-18___mMV_R`,
	"pB20": `AddButton-module__p-b-20___WCooU`,
	"pB25": `AddButton-module__p-b-25___M6vtA`,
	"pB30": `AddButton-module__p-b-30___W9T0P`,
	"pB50": `AddButton-module__p-b-50___sWrBl`,
	"pT0": `AddButton-module__p-t-0___pGP5w`,
	"pT12": `AddButton-module__p-t-12___dAv64`,
	"pT16": `AddButton-module__p-t-16___U80jw`,
	"pT18": `AddButton-module__p-t-18___WdXmw`,
	"pT20": `AddButton-module__p-t-20___bu1x4`,
	"pT30": `AddButton-module__p-t-30___lZXS4`,
	"pT40": `AddButton-module__p-t-40___wjFoc`,
	"pT50": `AddButton-module__p-t-50___eDcZI`,
	"pL20": `AddButton-module__p-l-20___wtrL5`,
	"pL30": `AddButton-module__p-l-30___iv6Bl`,
	"pL40": `AddButton-module__p-l-40___jQZFh`,
	"pR16": `AddButton-module__p-r-16___JJ0ne`,
	"pR20": `AddButton-module__p-r-20___CYadp`,
	"pR30": `AddButton-module__p-r-30___UIIOy`,
	"pR50": `AddButton-module__p-r-50___BMjNX`,
	"pR60": `AddButton-module__p-r-60___p3kuf`,
	"mB1": `AddButton-module__m-b-1___U2ftr`,
	"mB2": `AddButton-module__m-b-2___d4WqM`,
	"mB6": `AddButton-module__m-b-6___eeyct`,
	"mB8": `AddButton-module__m-b-8___cOJR0`,
	"mB10": `AddButton-module__m-b-10___aj2tu`,
	"mB14": `AddButton-module__m-b-14___vogDk`,
	"mB16": `AddButton-module__m-b-16___AYM4i`,
	"mB20": `AddButton-module__m-b-20___Iv2zJ`,
	"mB22": `AddButton-module__m-b-22___OphHL`,
	"mB24": `AddButton-module__m-b-24___QzLrS`,
	"mB30": `AddButton-module__m-b-30___Am6ze`,
	"mB32": `AddButton-module__m-b-32___xewkH`,
	"mB40": `AddButton-module__m-b-40___wEjTN`,
	"mT2": `AddButton-module__m-t-2___nWl4o`,
	"mT3": `AddButton-module__m-t-3___KFonQ`,
	"mT4": `AddButton-module__m-t-4___a_MqH`,
	"mT5": `AddButton-module__m-t-5___tIpt0`,
	"mT8": `AddButton-module__m-t-8___vWehY`,
	"mT10": `AddButton-module__m-t-10___ZLdU4`,
	"mT15": `AddButton-module__m-t-15___fR5sk`,
	"mT16": `AddButton-module__m-t-16___fJGMG`,
	"mT20": `AddButton-module__m-t-20___DBIMn`,
	"mT22": `AddButton-module__m-t-22___hZRqA`,
	"mT30": `AddButton-module__m-t-30___y9a2x`,
	"mT32": `AddButton-module__m-t-32___OZcKN`,
	"mLAuto": `AddButton-module__m-l-auto___GMTsu`,
	"mL4": `AddButton-module__m-l-4___oiiQ4`,
	"mL5": `AddButton-module__m-l-5___P9wrU`,
	"mL6": `AddButton-module__m-l-6___ndj17`,
	"mL8": `AddButton-module__m-l-8___o2YZs`,
	"mL10": `AddButton-module__m-l-10___aGq7o`,
	"mL16": `AddButton-module__m-l-16___lg0Jf`,
	"mL20": `AddButton-module__m-l-20___SWbpq`,
	"mL24": `AddButton-module__m-l-24___X1wqi`,
	"mL30": `AddButton-module__m-l-30___p510b`,
	"mL35": `AddButton-module__m-l-35___AU6zi`,
	"mL40": `AddButton-module__m-l-40___nameI`,
	"mR8": `AddButton-module__m-r-8___a2_Ya`,
	"mR10": `AddButton-module__m-r-10___IYEfO`,
	"mR16": `AddButton-module__m-r-16___IPnkt`,
	"mR20": `AddButton-module__m-r-20___cPtxl`,
	"mR24": `AddButton-module__m-r-24___J4UgK`,
	"mR30": `AddButton-module__m-r-30___hx4wE`,
	"mR40": `AddButton-module__m-r-40___EJioZ`,
	"borderR3": `AddButton-module__border-r-3___isKNG`,
	"borderR4": `AddButton-module__border-r-4___SDSnA`,
	"borderR6": `AddButton-module__border-r-6___XZBBV`,
	"borderR10": `AddButton-module__border-r-10___DInwS`,
	"borderR12": `AddButton-module__border-r-12___jPnYS`,
	"borderR16": `AddButton-module__border-r-16___tYhWz`,
	"borderR50": `AddButton-module__border-r-50___A_SEC`,
	"primaryBorder": `AddButton-module__primary-border___TmLq5`,
	"primaryBorderB": `AddButton-module__primary-border-b___QnUEr`,
	"primaryBorderT": `AddButton-module__primary-border-t___kMWzv`,
	"primaryBorderL": `AddButton-module__primary-border-l___uEyku`,
	"primaryBorderR": `AddButton-module__primary-border-r___UIoqf`,
	"secondaryBorder": `AddButton-module__secondary-border___Vwgsn`,
	"secondaryBorderB": `AddButton-module__secondary-border-b___wfh6I`,
	"secondaryBorderT": `AddButton-module__secondary-border-t___FRtL6`,
	"secondaryBorderL": `AddButton-module__secondary-border-l___yE4Ve`,
	"secondaryBorderR": `AddButton-module__secondary-border-r___p9Bju`,
	"gap0": `AddButton-module__gap-0___dJHMH`,
	"gap2": `AddButton-module__gap-2___B_j_r`,
	"gap4": `AddButton-module__gap-4___CTwFe`,
	"gap5": `AddButton-module__gap-5___kd6oy`,
	"gap6": `AddButton-module__gap-6___RBMlo`,
	"gap8": `AddButton-module__gap-8___Xkc7T`,
	"gap10": `AddButton-module__gap-10___hHtMr`,
	"gap12": `AddButton-module__gap-12___GnrsF`,
	"gap14": `AddButton-module__gap-14___V1VhR`,
	"gap16": `AddButton-module__gap-16___W_sT2`,
	"gap18": `AddButton-module__gap-18___ezMcJ`,
	"gap20": `AddButton-module__gap-20___P0_w8`,
	"gap24": `AddButton-module__gap-24___t11KW`,
	"gap26": `AddButton-module__gap-26___Xc888`,
	"gap30": `AddButton-module__gap-30___zkuFX`,
	"gap32": `AddButton-module__gap-32___GanZ1`,
	"gap40": `AddButton-module__gap-40___ooUB0`,
	"gap50": `AddButton-module__gap-50___wBchX`,
	"flex1": `AddButton-module__flex-1___a4emn`,
	"flexNone": `AddButton-module__flex-none___tOlHW`,
	"flexColumn": `AddButton-module__flex-column___bz1ep`,
	"flexRow": `AddButton-module__flex-row___mahn5`,
	"verticallyCentered": `AddButton-module__vertically-centered___ZTRJs`,
	"horizontallyCentered": `AddButton-module__horizontally-centered___QhQGJ`,
	"horizontallyEnd": `AddButton-module__horizontally-end___c4ZM0`,
	"verticallyStart": `AddButton-module__vertically-start___kiD6x`,
	"spaceBetween": `AddButton-module__space-between___RUp5o`,
	"flexWrap": `AddButton-module__flex-wrap___yFdE0`,
	"height100": `AddButton-module__height-100___hN1lM`,
	"width50": `AddButton-module__width-50___NLM70`,
	"width100": `AddButton-module__width-100___BJs3N`,
	"cursorPointer": `AddButton-module__cursor-pointer___bByPD`,
	"cursorNotAllowed": `AddButton-module__cursor-not-allowed___LtuJF`,
	"absoluteCentered": `AddButton-module__absolute-centered___EN1VX`,
	"absolute": `AddButton-module__absolute___pI0zI`,
	"relative": `AddButton-module__relative___BzWxA`,
	"fixed": `AddButton-module__fixed___fl0Po`,
	"visible": `AddButton-module__visible___N7eRH`,
	"invisible": `AddButton-module__invisible____4sd6`,
	"col90": `AddButton-module__col-90___KAEdM`,
	"colAuto": `AddButton-module__col-auto___kbwQc`,
	"medicalTabs": `AddButton-module__medical-tabs___8qfEu`,
	"medicalTableNew": `AddButton-module__medical-table-new___hflpN`,
	"noPagination": `AddButton-module__no-pagination___StTo1`,
	"medicalTableEmpty": `AddButton-module__medical-table-empty___scGyG`,
	"iconBtn": `AddButton-module__icon-btn___WWLwW`,
	"searchIcon": `AddButton-module__search-icon___PccBs`,
	"disableSelect": `AddButton-module__disable-select___I64Es`,
	"breakWord": `AddButton-module__break-word___RpGOR`,
	"popupClearBtn": `AddButton-module__popup-clear-btn___ASDMK`,
	"scrollMB20": `AddButton-module__scroll-m-b-20___Sat4c`,
	"button": `AddButton-module__button___vNoC4`
};
module.exports = ___CSS_LOADER_EXPORT___;
